<div
  #dropListContainer
  [class.has-files]="selectedFiles?.length > 0"
  [class.image]="!!props.image"
  [class.multiple]="props.multiple"
  class="upload-container flex-wrap"
  cdkDropListGroup
>
  <astrobin-loading-indicator *ngIf="(loadingService.loading$ | async) === true"></astrobin-loading-indicator>

  <ng-container *ngIf="(loadingService.loading$ | async) === false">
    <div *ngIf="selectedFiles?.length === 0">
      <ng-container *ngTemplateOutlet="fileChooserTemplate"></ng-container>
    </div>

    <div *ngFor="let selectedFile of selectedFiles; let i = index" [cdkDropListData]="i" class="files" cdkDropList>
      <div
        [cdkDragData]="i"
        (cdkDragDropped)="dragDropped($event)"
        (cdkDragEntered)="dragEntered($event)"
        (cdkDragMoved)="dragMoved($event)"
        class="file"
        cdkDrag
      >
        <img *ngIf="!!props.image; else notImageTemplate" [src]="selectedFile.url" alt="" />
        <ng-template #notImageTemplate>
          {{ selectedFile.file.name }}
        </ng-template>

        <span *ngIf="props.multiple" class="index">{{ i + 1 }}</span>
        <span (click)="onDelete($event, i)" class="delete">&times;</span>
      </div>
    </div>
  </ng-container>
</div>

<div *ngIf="props.multiple && selectedFiles?.length > 0">
  <ng-container *ngTemplateOutlet="fileChooserTemplate"></ng-container>
</div>

<ng-template #fileChooserTemplate>
  <div
    [class.has-files]="selectedFiles?.length > 0"
    (click)="openFileInput()"
    class="file-chooser d-flex flex-column text-center"
  >
    <div class="file-icon">
      <fa-icon *ngIf="!!props.image" icon="image"></fa-icon>
      <fa-icon *ngIf="!props.image" icon="file"></fa-icon>
    </div>
    <ng-container *ngIf="!props.hideLabel">
      <span *ngIf="!!props.image">
        <ng-container *ngIf="props.multiple">
          <ng-container *ngIf="selectedFiles?.length > 0">
            {{ "Add images" | translate }}
          </ng-container>
          <ng-container *ngIf="selectedFiles?.length === 0">
            {{ "Choose images" | translate }}
          </ng-container>
          <ng-container *ngTemplateOutlet="maxFilesTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="!props.multiple">
          {{ "Choose image" | translate }}
        </ng-container>
      </span>

      <span *ngIf="!props.image">
        <ng-container *ngIf="props.multiple">
          <ng-container *ngIf="selectedFiles?.length > 0">
            {{ "Add files" | translate }}
          </ng-container>
          <ng-container *ngIf="selectedFiles?.length === 0">
            {{ "Choose files" | translate }}
          </ng-container>
          <ng-container *ngTemplateOutlet="maxFilesTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="!props.multiple">
          {{ "Choose file" | translate }}
        </ng-container>
      </span>
    </ng-container>

    <input
      #fileInput
      [accept]="props.accept || '*'"
      [formlyAttributes]="field"
      [multiple]="props.multiple || false"
      (change)="onChange($event)"
      id="file-input"
      style="display: none"
      type="file"
    />
  </div>
</ng-template>

<ng-template #maxFilesTemplate>
  <ng-container *ngIf="props.maxFiles">
    <div class="text-muted">({{ selectedFiles.length }}/{{ props.maxFiles }})</div>
  </ng-container>
</ng-template>
